import { fromJS, Map } from "immutable";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import { USER_SET, USER_CLEAR } from "./actions";

interface User {
    [x: string]: any;
}
type UserAction = Action<User>;

const initialState = Map({});

const fnMap = {
    [USER_SET]: (s: ReducerState, a: UserAction) => fromJS(a.payload),
    [USER_CLEAR]: (s: ReducerState) => s.clear(),
};
//@ts-ignore
export const userReducer = reducerFn("user", initialState, fnMap);
